module.exports = __webpack_public_path__ + "static/media/pep-circle-ausfluege.af110e0f.png";